import type { AiGatewayAdvice } from "./client";

export const AI_MANAGER_PURPOSES = [
  { id: "farm_overview", label: "نمای کلی سالن" },
  { id: "breeding_review", label: "بررسی تکثیر" },
  { id: "feeding_review", label: "بررسی تغذیه" },
  { id: "health_review", label: "سلامت و درمان" },
  { id: "finance_review", label: "مالی و انبار" },
] as const;

export type AiManagerPurpose = (typeof AI_MANAGER_PURPOSES)[number]["id"];

export const AI_MANAGER_LOOKBACK_DAYS = [7, 30, 90] as const;
export type AiManagerLookbackDays = (typeof AI_MANAGER_LOOKBACK_DAYS)[number];

export interface AiAdviceStatusCopy {
  tone: "warning" | "danger";
  message: string;
}

export function aiAdviceStatusCopy(
  status: AiGatewayAdvice["status"],
): AiAdviceStatusCopy | undefined {
  switch (status) {
    case "ok":
      return undefined;
    case "disabled":
      return {
        tone: "warning",
        message: "هوش مصنوعی برای این سالن غیرفعال است. از تنظیمات مدیر آن را فعال کنید.",
      };
    case "not_configured":
      return {
        tone: "warning",
        message: "تنظیمات Provider یا کلید API هنوز برای این سالن کامل نشده است.",
      };
    case "permission_denied":
      return {
        tone: "danger",
        message: "این حساب اجازه استفاده از مشاور هوش مصنوعی را ندارد.",
      };
    case "invalid_settings":
      return {
        tone: "warning",
        message: "تنظیمات هوش مصنوعی معتبر نیست. تنظیمات Provider را بررسی کنید.",
      };
    case "provider_unavailable":
      return {
        tone: "warning",
        message: "Provider هوش مصنوعی پاسخ معتبر نداد. تنظیمات یا Provider جایگزین را بررسی کنید.",
      };
    case "failed":
      return {
        tone: "danger",
        message: "تحلیل هوشمند انجام نشد. بدون تغییر داده‌های سالن می‌توانید دوباره تلاش کنید.",
      };
  }
}
